import { GridListTile } from 'pages/Registration/ResponsiveGridList';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles, Theme } from '@material-ui/core';
import multiRegisterImage from 'static/img/multiple-registrations.png';

const teal5 = '#f4fafa';

interface MultipleRegistrationCardTile {
  onClick: () => void;
}

const MultipleRegistrationTile: React.FunctionComponent<MultipleRegistrationCardTile> = (props) => {
  const classes = styles(props);
  const intl = useIntl();
  const { onClick, ...styleProps } = props;

  return (
    <GridListTile
      {...styleProps}
      name={intl.formatMessage({ id: 'registerMultipleIngredients' })}
      image={multiRegisterImage}
      value={intl.formatMessage({ id: 'registerMultipleIngredients' })}
      onClick={onClick}
      isSelected={null}
      className={classes.tile}
    />
  );
};

const styles = makeStyles<Theme, MultipleRegistrationCardTile>({
  tile: {
    '& > *': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: teal5,
      padding: '20px 20px 50px 20px'
    },
    '& img': {
      position: 'static',
      transform: 'none',
      paddingTop: '20px',
      width: '100% !important',
      height: 'auto !important'
    }
  }
});

export default MultipleRegistrationTile;
